import React from 'react';
import { IconProps } from '.';

const SvgThumbsUp = ({
  size = 16,
  color = '#292B2B',
  secondaryColor = '#B3BABD',
  className,
  ...props
}: IconProps): JSX.Element => {
  return (
    <svg
      width={size}
      height={size}
      fill='none'
      viewBox='0 0 24 24'
      className={className ? 'pds-icon ' + className : 'pds-icon'}
      {...props}
    >
      <path
        fill={color}
        fillRule='evenodd'
        d='M11.836 2.25h.428c.704 0 1.707.114 2.48.724.844.667 1.224 1.766.96 3.303l-.012.066L14.57 9.45h4.574c1.418 0 2.607 1.12 2.607 2.55v.058l-1.5 9.692h-18V9.25h5.441l4.145-7ZM8.75 10.405l3.93-6.636c.446.043.852.16 1.134.382.29.229.6.692.422 1.809l-1.805 4.99h6.712c.615 0 1.079.463 1.106 1l-1.285 8.3H8.75v-9.845Zm-1.5 9.845v-9.5h-3.5v9.5h3.5Z'
        clipRule='evenodd'
      />
    </svg>
  );
};

export default SvgThumbsUp;
